import { IPortfolioFeesTreeNode } from "../api/PortfolioApi";

export enum AccountType {
    ATOMIC = 1,
    COMPOSITE = 2,
    BENCHMARK_OR_PEER = 3
}

export interface ITreeNodeBase {
    id: number,
    name: string,
    sortOrder: number,
    accountType: AccountType,
    date: string,
    backstopId?: string,
    parentId?: number | null,
}

export interface IPortfolioPerformance {
    quarter: number | null,
    ytd: number | null,
    year: number | null,
    threeYears: number | null,
    fiveYears: number | null,
    tenYears: number | null
}

export interface IPlanTreeNode extends ITreeNodeBase {
    marketValue: number,
    marketValuePctOfTotal: number,
    marketValuePctOfParent: number,
    relativePerformance: IPortfolioPerformance,
    absolutePerformance: IPortfolioPerformance,
    priorMarketValuePctOfTotal?: number | undefined;
    managementType?: string | undefined;
    benchmarkId?: number | undefined;
    rating?: string | undefined;
    ifaRating?: string | undefined;
}

export interface IPlanTreeTargetAllocation {
    accountName: string,
    marketValuePctOfTotal: number,
    targetAllocation: number,
    asOfDate: string;
}

export interface IPlanTreeQuarterlyPerformance {
    date: Date,
    quarterAbsolute?: number | null,
    quarterRelative?: number | null,
    benchmarkName?: string,
}

export interface IAssetAllocationTreeNode extends ITreeNodeBase {
    nodes?: IAssetAllocationTreeNode[] | null;
    marketValue: number,
    marketValuePctOfTotal: number,
    marketValuePctOfParent: number,
    rating: string,
    priorMarketValuePctOfTotal?: number;
}

export interface IPerformanceTreeNode extends ITreeNodeBase {
    nodes?: IPerformanceTreeNode[] | null;
    relativePerformance: IPortfolioPerformance;
    absolutePerformance: IPortfolioPerformance;
    managementType?: string | undefined;
    ranking?: IPortfolioPerformance | null;
}

export interface IBenchmarkReturn {
    benchmarkId: number;
    name: string;
    date: string;
    performance: IPortfolioPerformance;
}

export interface IFeesTreeNode extends IPortfolioFeesTreeNode {
    nodes: IFeesTreeNode[] | null;
}